import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {IUserEntity, UserEntity} from 'app/blocks/model/user-entity.model';
import {SERVER_API_URL} from 'app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class UserService extends EntityCrudService<IUserEntity> {
    constructor(http: HttpClient) {
        super(http, Resource.USERS, (obj?) => new UserEntity(obj));
    }

    activateUsers(ids): Promise<any> {
        return this.http.post(`${SERVER_API_URL}api/users/activate`, {ids}).toPromise();
    }

    deactivateUsers(ids): Promise<any> {
        return this.http.post(`${SERVER_API_URL}api/users/deactivate`, {ids}).toPromise();
    }
}
